import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

/* ==================================================================
 * COOKIE INJECTOR (for cookie scanning)
 * Auto-injects a fixed cookie set on EVERY page load — no click, no
 * consent gate — so a scanner opening this page in a fresh session can
 * discover the cookies. Uses the native cookie setter, so it works even
 * if the page has a consent blocker overriding document.cookie.
 * ================================================================== */
function injectCookies() {
  // Cookies to inject, grouped by category. Edit to match your template.
  const SEED = {
    Necessary: ["session_id", "csrftoken", "XSRF-TOKEN"],
    Analytics: ["_ga", "_gid", "_gat", "_clck"],
    Advertisement: ["_fbp", "_gcl_au", "IDE", "MUID"],
    Functional: ["lang", "pref_theme"],
    Others: ["widget_state", "ab_variant"],
  };
  const MAX_AGE = 365 * 24 * 60 * 60; // 1 year

  // Native (prototype-level) cookie setter — bypasses any document.cookie override.
  const desc =
    Object.getOwnPropertyDescriptor(Document.prototype, "cookie") ||
    (typeof HTMLDocument !== "undefined" &&
      Object.getOwnPropertyDescriptor(HTMLDocument.prototype, "cookie"));
  const set =
    desc && desc.set
      ? (s) => desc.set.call(document, s)
      : (s) => {
          document.cookie = s;
        };

  const secure = location.protocol === "https:" ? "; secure" : "";
  const names = [];
  Object.values(SEED).forEach((list) =>
    list.forEach((name) => {
      const val = `${name}_${Math.random().toString(36).slice(2, 12)}`;
      set(
        `${name}=${encodeURIComponent(val)}; path=/; max-age=${MAX_AGE}; SameSite=Lax${secure}`
      );
      names.push(name);
    })
  );
  console.log(`[CookieInjector] injected ${names.length} cookies`, names);
}

try {
  injectCookies();
} catch (e) {
  console.warn("[CookieInjector] failed:", e);
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
